<template>
  <div class="col-12 relative grey-bg full-height flex flex-column">
    <template v-if="routeMatchesComponent() && !route.meta.breadcrumb">
      <!-- TODO Improves -->
      <CategoryHeader :title="route.meta.title" :icon="route.meta.icon" />
    </template>
    <div v-if="loading" class="relative full-height flex items-center justify-center pb5">
      <div class="center">
        <div class="list-loader-blue"></div>
      </div>
    </div>
    <HistoryList v-else-if="routeMatchesComponent()" />
    <router-view v-else />
  </div>
</template>

<script>
import { getCurrentInstance, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import CategoryHeader from '@/components/common/CategoryHeader';
import HistoryList from '@/components/history/HistoryList';

import { routeIsCurrentComponent } from '@/mixins/utils';

export default {
  components: {
    CategoryHeader,
    HistoryList
  },
  setup () {
    const route = useRoute();
    const store = useStore();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());
    const loading = computed(() => store.state.loadingContent);

    return {
      route,
      loading,
      routeMatchesComponent
    };
  }
};
</script>
